// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-text[data-v-0f3e4e3c]{grid-gap:.75rem;gap:.75rem}.card-compliance[data-v-0f3e4e3c]{font-size:14px;margin-top:10px;font-size:13px;font-weight:lighter}.pros-and-info[data-v-0f3e4e3c]{flex-direction:column}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
